import { Component, OnInit } from '@angular/core';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { PessoaLookupService } from '../../../../../shared/services/apis/pessoa/pessoa-lookup.service';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { LookupItemStruct } from '../../../../../shared/services/structs/pessoa/lookup-item.struct';

@Component({
  selector: 'app-dialog-vincular-vendedor',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
  ],
  templateUrl: './dialog-vincular-vendedor.component.html',
  styleUrls: ['./dialog-vincular-vendedor.component.css'],
})
export class DialogVincularVendedorComponent implements OnInit {
  selectedVendedorId: number | null = null;
  vendedores: LookupItemStruct[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogVincularVendedorComponent>,
    private pessoaLookupService: PessoaLookupService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.carregarVendedores();
  }

  carregarVendedores(): void {
    this.pessoaLookupService.listVendedorSelect().subscribe({
      next: response => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
        } else {
          this.vendedores = response.list || [];
        }
      },
      error: err => {
        this.alertService.show('Erro', 'Falha ao carregar vendedores.', AlertType.error);
      },
    });
  }

  cancelar(): void {
    this.dialogRef.close();
  }

  confirmar(): void {
    this.dialogRef.close(this.selectedVendedorId);
  }
}
